

import Toast from './toast.js'

//available classes to use
//mandatoryField : will be used in inputFieldMandatoryCheck(),to check if value empty or not
//specialCharactersAllowed : will be used in inputFieldValueCompositionCheck(),to check 
//                if value composition is matching with inputFieldValueCompositionWithSpecialCharactersRegex
//typeEmail : will be used in inputFieldValueCompositionCheck(),to check if value composition is matching with emailRegex
//typePassword : will be used in inputFieldValueCompositionCheck(),to check if value composition is matching with passwordRegex   

function inputFieldMandatoryCheck(formElemId,locales,showToast) {
    var isContinue = true;
    var allInputElements = document.getElementById(formElemId).getElementsByClassName('input_data');
    console.log("allElements>>>>",allInputElements)
    for(var i = 0; i < allInputElements.length; i++){
        var currentInputElement = allInputElements.item(i);
        var currentErrorDescElement = currentInputElement.closest(".form-group").getElementsByClassName("errorDesc")[0];
        var currentMandatoryErrorMessage = currentInputElement.getAttribute("mandatoryErrorMessage");
        currentInputElement.classList.remove("erroredInput");//remove class if already errored
        currentErrorDescElement.innerHTML = "";  
        if(currentInputElement.classList.contains('mandatoryField') || currentInputElement.classList.contains('mandatoryFieldSpecial') || currentInputElement.classList.contains('mandatoryFieldWithoutStyle') || currentInputElement.classList.contains('mandatoryFieldWithSozaStyle')  ){
            if(currentInputElement.classList.contains('typeReactSelect')){
                if(currentInputElement.querySelectorAll('div[class$="multiValue"]').length<1){
                    isContinue = false;
                    currentInputElement.classList.add("erroredInput");
                    if(currentMandatoryErrorMessage){
                        currentErrorDescElement.innerHTML = currentMandatoryErrorMessage;
                    }else{
                        currentErrorDescElement.innerHTML = "mandatory field";
                    }
                }
            }else if(currentInputElement.value === ""){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                if(currentMandatoryErrorMessage){
                    currentErrorDescElement.innerHTML = currentMandatoryErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "Mandatory field";
                }
            }
        }
    }
    if(showToast){
         if(!isContinue){Toast.showToast("Fill all mandatory fields");}
    }
    return isContinue;
}

function inputFieldValueCompositionCheck(formElemId,locales,showToast) {
    let inputFieldValueCompositionRegex = new RegExp(decodeURIComponent(locales.inputFieldValueCompositionRegex));
    let inputFieldValueCompositionWithSpecialCharactersRegex = new RegExp(decodeURIComponent(locales.inputFieldValueCompositionWithSpecialCharactersRegex));
    let passwordRegex = new RegExp(decodeURIComponent(locales.passwordRegex));
    let emailRegex = new RegExp(decodeURIComponent(locales.emailRegex));
    let numberRegex = new RegExp(decodeURIComponent(locales.numberRegex));
    let contactNumRegex = new RegExp(decodeURIComponent(locales.contactNumRegex));
    let zipRegex = new RegExp(decodeURIComponent(locales.zipRegex));
    let nameRegex = new RegExp(decodeURIComponent(locales.nameRegex));
    let dataRegex = new RegExp(decodeURIComponent(locales.dataRegex));
    let descriptionRegex = new RegExp(decodeURIComponent(locales.descriptionRegex));
    let pinRegex= new RegExp(decodeURIComponent(locales.pinRegex));
    let ssnRegex= new RegExp(decodeURIComponent(locales.ssnRegex));
    let amountRegex= new RegExp(decodeURIComponent(locales.amountRegex));
    var isContinue = true;
    var allInputElements = document.getElementById(formElemId).getElementsByClassName('input_data');
    for(var i = 0; i < allInputElements.length; i++){
        var currentInputElement = allInputElements.item(i);
        var currentErrorDescElement = currentInputElement.closest(".form-group").getElementsByClassName("errorDesc")[0];
        var currentInputElementValue = "";

        if(currentInputElement.getAttribute("originalValue")){
            currentInputElementValue = currentInputElement.getAttribute("originalValue");
        }else{
            currentInputElementValue = currentInputElement.value;
        }

        var currentValueCompositionErrorMessage = currentInputElement.getAttribute("valueCompositionErrorMessage");
        var isSpecialCharactersAllowed = false;
        var isEmail = false;
        var isPassword = false;
        var isNumber= false;
        var isContactNum= false;
        var isZip= false;
        var isTypeName = false;
        var isMandatory= false;
        var isTypeEmailOrName = false;
        var isValidDescription = false;
        var isValidData = false;
        var isPin= false;
        var isSsn= false;
        var isTypeAmount= false;
        if(currentInputElement.classList.contains('specialCharactersAllowed')){isSpecialCharactersAllowed = true}
        if(currentInputElement.classList.contains('typeEmail')){isEmail = true}
        if(currentInputElement.classList.contains('typePassword')){isPassword = true}
        if(currentInputElement.classList.contains('typeNumber')){isNumber = true}
        if(currentInputElement.classList.contains('typeContactNum')){isContactNum = true}
        if(currentInputElement.classList.contains('typeZip')){isZip = true}
        if(currentInputElement.classList.contains('typeName')){isTypeName = true}
        if(currentInputElement.classList.contains('validDescription')){isValidDescription = true}
        if(currentInputElement.classList.contains('validData')){isValidData = true}
        if(currentInputElement.classList.contains('typeEmailOrName')){isTypeEmailOrName = true}
        if(currentInputElement.classList.contains('mandatoryField')){isMandatory = true}
        if(currentInputElement.classList.contains('mandatoryFieldSpecial')){isMandatory = true}
        if(currentInputElement.classList.contains('mandatoryFieldWithoutStyle')){isMandatory = true}
        if(currentInputElement.classList.contains('typePin')){isPin = true}
        if(currentInputElement.classList.contains('typeSsn')){isSsn = true}
        if(currentInputElement.classList.contains('typeAmount')){isTypeAmount = true}
        // currentInputElement.classList.remove("erroredInput");//remove class if already errored
        if(currentErrorDescElement.innerHTML === ""){currentErrorDescElement.innerHTML = "";}
        if(isEmail){
            if(currentInputElementValue !== "" && emailRegex.test(currentInputElementValue) !== true){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                if(currentValueCompositionErrorMessage){
                    currentErrorDescElement.innerHTML = currentValueCompositionErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "Please enter valid Email Address";
                }
            }
        }else if(isPassword){
            if(currentInputElementValue !== "" && passwordRegex.test(currentInputElementValue) !== true){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                if(currentValueCompositionErrorMessage){
                    currentErrorDescElement.innerHTML = currentValueCompositionErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "Invalid format";
                }
            }
        }else if(isSpecialCharactersAllowed){
            if(currentInputElementValue !== "" && inputFieldValueCompositionWithSpecialCharactersRegex.test(currentInputElementValue) !== true){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                if(currentValueCompositionErrorMessage){
                    currentErrorDescElement.innerHTML = currentValueCompositionErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "Please enter valid value";
                }
            }
        }else if(isNumber){
            if(currentInputElementValue !== "" && numberRegex.test(currentInputElementValue) !== true){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                if(currentValueCompositionErrorMessage){
                    currentErrorDescElement.innerHTML = currentValueCompositionErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "Please enter only numeric value";
                }
            }
        }else if(isTypeAmount){
            if(currentInputElementValue !== "" && amountRegex.test(currentInputElementValue) !== true){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                if(currentValueCompositionErrorMessage){
                    currentErrorDescElement.innerHTML = currentValueCompositionErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "Please enter only numeric value";
                }
            }
        }else if(isContactNum){
            if(isMandatory && currentInputElementValue !== "" && contactNumRegex.test(currentInputElementValue) !== true){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                if(currentValueCompositionErrorMessage){
                    currentErrorDescElement.innerHTML = currentValueCompositionErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "Please enter valid phone number";
                }
            }
            else if(currentInputElementValue !== "+1" && contactNumRegex.test(currentInputElementValue) !== true){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                if(currentValueCompositionErrorMessage){
                    currentErrorDescElement.innerHTML = currentValueCompositionErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "Please enter valid phone number";
                }
            }
        }else if(isZip){
            if(currentInputElementValue !== "" && zipRegex.test(currentInputElementValue) !== true){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                  if(currentValueCompositionErrorMessage){
                    currentErrorDescElement.innerHTML = currentValueCompositionErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "invalid values";
                }
            }
        } else if(isTypeName){
            if(currentInputElementValue !== "" && nameRegex.test(currentInputElementValue) !== true){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                if(currentValueCompositionErrorMessage){
                    currentErrorDescElement.innerHTML = currentValueCompositionErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "Please enter valid name";
                }
            }
        }else if(isValidDescription){
            console.log("currentInputElementValue",currentInputElementValue)
            console.log("descriptionRegex.test(currentInputElementValue)",descriptionRegex.test(currentInputElementValue))
            if(currentInputElementValue !== "" && descriptionRegex.test(currentInputElementValue) !== true){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                if(currentValueCompositionErrorMessage){
                    currentErrorDescElement.innerHTML = currentValueCompositionErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "invalid values";
                }
            }
        }  else if(isValidData){
            if(currentInputElementValue !== "" && dataRegex.test(currentInputElementValue) !== true){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                if(currentValueCompositionErrorMessage){
                    currentErrorDescElement.innerHTML = currentValueCompositionErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "invalid values";
                }
            }
        } else if(isTypeEmailOrName){
            if(currentInputElementValue !== "" && (nameRegex.test(currentInputElementValue) !== true && emailRegex.test(currentInputElementValue) !== true)){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                if(currentValueCompositionErrorMessage){
                    currentErrorDescElement.innerHTML = currentValueCompositionErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "Please enter valid username";
                }
            }
        }else if(isPin){
            if(currentInputElementValue !== "" && pinRegex.test(currentInputElementValue) !== true){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                  if(currentValueCompositionErrorMessage){
                    currentErrorDescElement.innerHTML = currentValueCompositionErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "PIN should be a 4 digit number";
                }
            }
        }else if(isSsn){
            if(currentInputElementValue !== "" && ssnRegex.test(currentInputElementValue) !== true){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                  if(currentValueCompositionErrorMessage){
                    currentErrorDescElement.innerHTML = currentValueCompositionErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "SSN should be a 9 digit number";
                }
            }
        }  else{
            if(currentInputElementValue !== "" && inputFieldValueCompositionRegex.test(currentInputElementValue) !== true){
                isContinue = false;
                currentInputElement.classList.add("erroredInput");
                if(currentValueCompositionErrorMessage){
                    currentErrorDescElement.innerHTML = currentValueCompositionErrorMessage;
                }else{
                    currentErrorDescElement.innerHTML = "Please enter correct values";
                }
            }
        }
    }
    if(showToast){
        if(!isContinue){Toast.showToast("Invalid values");}
   }
 
    return isContinue;
}

function inputFieldMaxLengthCheck(formElemId,locales,showToast) {
    let inputFieldMaxLengthRegex = new RegExp(decodeURIComponent(locales.inputFieldMaxLengthRegex));
    var isContinue = true;
    var allInputElements = document.getElementById(formElemId).getElementsByClassName('input_data');
    for(var i = 0; i < allInputElements.length; i++){
        var currentInputElement = allInputElements.item(i);
        var currentErrorDescElement = currentInputElement.closest(".form-group").getElementsByClassName("errorDesc")[0];
        var currentInputElementValue = currentInputElement.value;
        var currentMaxLengthErrorMessage = currentInputElement.getAttribute("maxLengthErrorMessage"); 

        // var allowedMinLength = currentInputElement.getAttribute("minLength"); 
        // var allowedMaxLength = currentInputElement.getAttribute("maxLength"); 
        // var currentValueLength = currentInputElementValue.length;

        if(currentErrorDescElement.innerHTML === ""){currentErrorDescElement.innerHTML = "";}
        // if(allowedMaxLength && (currentValueLength > allowedMaxLength)){
        //     isContinue = false;
        //     currentInputElement.classList.add("erroredInput");
        //     if(currentMaxLengthErrorMessage){
        //         currentErrorDescElement.innerHTML = currentMaxLengthErrorMessage;
        //     }else{
        //         currentErrorDescElement.innerHTML = "max length exceeded";
        //     }
        // }else 
        if(inputFieldMaxLengthRegex.test(currentInputElementValue) !== true){
            isContinue = false;
            currentInputElement.classList.add("erroredInput");
            if(currentMaxLengthErrorMessage){
                currentErrorDescElement.innerHTML = currentMaxLengthErrorMessage;
            }else{
                currentErrorDescElement.innerHTML = "max length exceeded";
            }
        }
    }
    if(showToast){
        if(!isContinue){Toast.showToast("max length exceeded");}
   }
    return isContinue;
}

export default {
    inputFieldMandatoryCheck,inputFieldValueCompositionCheck,inputFieldMaxLengthCheck
}
